import { RouteItem } from '@eastcoal/router/types/route'

import {
  APPLY_ANNOUNCEMENT_CHANNEL_PAGE_PATH,
  APPLY_ANNOUNCEMENT_CREATE_PAGE_PATH,
  APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH,
  APPLY_ANNOUNCEMENT_EDIT_PAGE_PATH,
  APPLY_ANNOUNCEMENT_LIST_PAGE_PATH
} from './constants/path'
import {
  APPLY_ANNOUNCEMENT_CHANNEL_ACTION_UUID,
  APPLY_ANNOUNCEMENT_LIST_ACTION_UUID,
  APPLY_ANNOUNCEMENT_LIST_PAGE_UUID
} from './constants/uuid'

export const applyAnnouncementRoute: RouteItem = {
  title: '竞价预告',
  hideChildrenInMenu: true,
  children: [
    {
      title: '预告列表',
      path: APPLY_ANNOUNCEMENT_LIST_PAGE_PATH,
      uuid: APPLY_ANNOUNCEMENT_LIST_PAGE_UUID,
      Component: () => import('./List')
    },
    {
      title: '新增文章',
      path: APPLY_ANNOUNCEMENT_CREATE_PAGE_PATH,
      uuid: APPLY_ANNOUNCEMENT_LIST_ACTION_UUID,
      Component: () => import('./Create')
    },
    {
      title: '编辑文章',
      path: APPLY_ANNOUNCEMENT_EDIT_PAGE_PATH,
      uuid: APPLY_ANNOUNCEMENT_LIST_ACTION_UUID,
      Component: () => import('./Edit')
    },
    {
      title: '查看文章',
      path: APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH,
      uuid: APPLY_ANNOUNCEMENT_LIST_ACTION_UUID,
      Component: () => import('./Detail')
    },
    {
      title: '管理频道',
      path: APPLY_ANNOUNCEMENT_CHANNEL_PAGE_PATH,
      uuid: APPLY_ANNOUNCEMENT_CHANNEL_ACTION_UUID,
      Component: () => import('../Channel')
    }
  ]
}
